<template>
  <div v-loading.fullscreen.lock="display.isLoading">
    <div class="inner-container">
      <!-- EFT -->
      <div v-if="order.paymentMethod === 'EFT'">
        <h3 class="centre">Bank Transfer Details</h3>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Account Name</el-col
          >
          <el-col :span="14" class="payment__col left">King Dynasty</el-col>
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold">BSB</el-col>
          <el-col :span="14" class="payment__col left">032006</el-col>
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Account Number</el-col
          >
          <el-col :span="14" class="payment__col left">689888</el-col>
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Amount</el-col
          >
          <el-col :span="14" class="payment__col left gold font-bold"
            >${{ order.amountDisplay }}</el-col
          >
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Order Number</el-col
          >
          <el-col :span="14" class="payment__col left">
            {{ order.orderNumber }}
            <el-button
              size="mini"
              class="bg-gold black"
              v-clipboard:copy="order.orderNumber"
              v-clipboard:success="onCopySuccess"
              v-clipboard:error="onCopyError"
              >Copy to Clipboard</el-button
            >
          </el-col>
        </el-row>
        <h4 class="payment__note">
          Please click the "Copy to Clipboard" button and transfer the amount to
          the mentioned bank account above with the order number as note. Please
          send proof of transaction receipt with your order number to Clients
          Service mobile
          <a class="gold" href="sms:+61406988000">"0406 988 000"</a> or WeChat
          account "kingdynastyone" for your order confirmation. We will process
          your order once we receive your payment. Please feel free to contact
          us for any questions. Thank you for choosing our services.
        </h4>
      </div>

      <!-- Cash or Card -->
      <div v-if="order.paymentMethod === 'CASH_OR_CARD'">
        <h3 class="centre">Cash Payment</h3>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Amount</el-col
          >
          <el-col :span="14" class="payment__col left gold font-bold"
            >${{ order.amountDisplay }}</el-col
          >
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Order Number</el-col
          >
          <el-col :span="14" class="payment__col left">{{
            order.orderNumber
          }}</el-col>
        </el-row>
        <h4 class="payment__note">
          Please pay at the counter referring to the amount and order number
          above.
        </h4>
      </div>

      <!-- Stripe -->
      <div v-if="order.paymentMethod === 'CREDIT_CARD'">
        <h3 class="centre">Credit Card Payment</h3>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Amount</el-col
          >
          <el-col :span="14" class="payment__col left gold font-bold"
            >${{ order.amountDisplay }}</el-col
          >
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Order Number</el-col
          >
          <el-col :span="14" class="payment__col left">{{
            order.orderNumber
          }}</el-col>
        </el-row>
        <h4 class="payment__note">
          We will redirect you to card payment hosted by stripe.com which
          provides secure online card payment. You will be redirected back to
          King Dynasty once payment is completed.
        </h4>
        <div class="centre">
          <el-button class="bg-black gold" @click="onClickCardCheckout"
            >Pay</el-button
          >
        </div>
      </div>

      <!-- Alipay -->
      <div v-if="order.paymentMethod === 'ALIPAY'">
        <h3 class="centre">Alipay Payment</h3>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Amount</el-col
          >
          <el-col :span="14" class="payment__col left gold font-bold"
            >${{ order.amountDisplay }}</el-col
          >
        </el-row>
        <el-row>
          <el-col :span="10" class="payment__col right font-bold"
            >Order Number</el-col
          >
          <el-col :span="14" class="payment__col left">{{
            order.orderNumber
          }}</el-col>
        </el-row>
        <h4 class="payment__note">
          We will redirect you to Alipay for payment. You will be redirected
          back to King Dynasty once payment is completed.
        </h4>
        <div class="centre">
          <el-button class="bg-black gold" @click="onClickAlipayCheckout"
            >Pay</el-button
          >
        </div>
      </div>

      <!-- Pay at Counter -->
      <div v-if="order.paymentMethod === 'PAY_AT_COUNTER'">
        <h3 class="centre">Pay at Counter</h3>
        <el-row :gutter="20">
          <el-col :span="10" class="right font-bold">Order Number</el-col>
          <el-col :span="14" class="left">{{ order.orderNumber }}</el-col>
        </el-row>
        <h4 class="payment__note">
          Thank you for choosing KingDynasty Online Service. Your dine-in order
          has been successfully placed.
        </h4>
        <p class="payment__note">
          We will serve you once your table/food is ready. All your meal will be
          pre-prepared while you are waiting to speed up your service.
        </p>
        <p class="payment__note">
          You can always add more dishes through Online Service as you wish.
          Please leave notes in the comment box for your waitlist number or
          table number for us to identify your order.
        </p>
        <p class="payment__note">
          Please feel free to contact our staff for any inquiry. Please also be
          noted that all of our Yum Cha/Dinner dine-in will have additional
          charge for tea service per head.
        </p>
        <p class="payment__note">
          We sincerely hope you enjoy dine in with us.
        </p>
      </div>
      <div class="centre back-btn">
        <el-button class="bg-gold black" @click="onClickHome"
          >Back to Home</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getById } from "@/api/order";
import { create } from "@/api/payment";
import logger from "@/utils/logger";
import { CHANNEL, PAYMENT_SOURCE } from "@/utils/payment";
import { loadStripe } from "@stripe/stripe-js";

const name = "Payment";
const log = logger(name);

export default {
  name,
  data() {
    return {
      order: {
        customer: {},
        shippingAddress: {},
        attributes: [],
        paymentMethod: "",
      },
      display: {
        isLoading: true,
      },
      stripe: null,
    };
  },
  computed: {
    ...mapGetters(["latestOrderId"]),
  },
  async created() {
    log.info("Created, order ID", this.latestOrderId);
    this.order = await getById(this.latestOrderId);
    this.order.amountDisplay = this.order.amount.toFixed(2);
    this.order.paymentMethod = this.order.attributes.find(
      (attr) => attr.key === "paymentMethod"
    ).value;
    this.display.isLoading = false;
    this.stripe = await loadStripe(
      process.env.NODE_ENV === "production"
        ? "pk_live_oj4FgfRIHcOaMDbrF2LgYvhJ00j0addPmk"
        : "pk_test_6ibiFoGsyD5IVWDeghFhNHFK0041mKAIea"
    );
  },
  methods: {
    onCopySuccess() {
      log.info("Copy success");
      this.$message({
        message: "Copied.",
        type: "success",
      });
    },
    onCopyError(err) {
      log.warn("Copy error", err);
      this.$message({
        message:
          "Cannot access clipboard, please try to copy the order number manually.",
        type: "error",
      });
    },
    onClickHome() {
      this.$router.replace("/");
    },

    async onClickCardCheckout() {
      this.display.isLoading = true;
      try {
        const { paymentGatewayData } = await create({
          orderId: this.order._id,
          externalOrderId: this.order.orderNumber,
          channel: CHANNEL.StripeCheckoutCreditCard,
          from: PAYMENT_SOURCE,
          platformData: { websiteUrl: location.origin },
        });
        const { id } = paymentGatewayData;
        await this.stripe.redirectToCheckout({ sessionId: id });
      } catch (err) {
        log.error("Failed to redirect to stripe checkout", err);
        this.$message({
          message: "Failed to make a payment.",
          type: "error",
        });
      } finally {
        this.display.isLoading = false;
      }
    },

    async onClickAlipayCheckout() {
      this.display.isLoading = true;
      try {
        const { paymentGatewayData } = await create({
          orderId: this.order._id,
          externalOrderId: this.order.orderNumber,
          channel: CHANNEL.OmipayAlipayOnline,
          from: PAYMENT_SOURCE,
          platformData: { websiteUrl: location.origin },
        });
        window.location.href = paymentGatewayData["pay_url"];
      } catch (err) {
        log.error("Failed to redirect to Alipay checkout", err);
        this.$message({
          message: "Failed to make a payment.",
          type: "error",
        });
      } finally {
        this.display.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.payment__col {
  padding: 0.4rem;
}

.payment__note {
  text-align: justify;
  text-justify: inter-ideograph;
  padding: 0.5rem;
}

.back-btn {
  margin-top: 1rem;
}

.inner-container {
  max-width: 992px;
  margin-left: auto;
  margin-right: auto;
}
</style>